import React from 'react';
import type { AdItem } from '@sbt-web/network/types';
import type { FC } from 'react';
import { buildImageObjSchema } from './utils';
import { jsonLdScriptProps } from 'react-schemaorg';

type Props = {
  adItems: AdItem[];
};

export const ImgObjSchemaListing: FC<Props> = ({ adItems }) => {
  const imgSchemaObjs = adItems
    .map((ad) => {
      const firstImage = ad.images?.[0];

      if (!firstImage) return null;

      return buildImageObjSchema({
        ad,
        image: `${firstImage.cdnBaseUrl}?rule=gallery-desktop-2x-auto`,
        isRepresentative: false,
      });
    })
    .filter((imgObj) => imgObj !== null);

  return imgSchemaObjs.length > 0 ? (
    <script
      key="listing-image-object"
      {...jsonLdScriptProps({
        '@context': 'https://schema.org',
        '@graph': imgSchemaObjs,
      })}
    />
  ) : null;
};
